export default __webpack_public_path__ + "static/media/PopUpTopArrow.e12fe57e.svg";